// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2kfCV","box":"WorkspacesBox_box__3zEGp","node":"WorkspacesBox_node__1LAdX"};